<template>
    <div class="left-aside">
        <div style="flex: 1;height: 100%;overflow-y: auto;" ref="emailContainer">
            <div v-for="(item, index) in dataList" :key="index"
                :class="selectMailIndex == index ? 'nav-item nav-item-selected' : 'nav-item'"
                @click="handleSelectMail(item, index)">
                <!-- <div style="text-align: left;margin-bottom: 0px;margin-right: 10px;" >
                    <p class="reply" :style="createReplyStatusStyle(item)">
                        {{ formatReplyStatus(item) }} </p>
                </div> -->

                <p class="email">{{ formatMailDate(item) }} | {{ item.fromName }} ({{ item.from }}) TO: {{ item.to }}
                </p>
                <p class="subject">{{ item.subject }} <span style="font-size: 12px;color: #bbb;font-weight: normal;">{{
                    item.content_plain && item.content_plain != '' && item.content_plain.length > 150 ?
                        item.content_plain.substring(0, 150) + '...' : item.content_plain }}</span></p>

                <p class="time"></p>
                <p class="email"></p>
                <div v-if="item.assigned_user_id">
                    <p class="email" style="margin-top: 5px;color:blue" v-if="item.assigned_user_id != -1">Assigned to :
                        {{
                            item.assigned_user?.user_lastName + " " +
                            item.assigned_user?.user_givenName }} <span
                            style="font-size: 12px;color: red;font-weight: normal;">({{ item.reply_instruction
                            }})</span></p>
                    <p class="email" style="margin-top: 5px;color:blue" v-else>Not Assigned</p>
                </div>
                <div style="text-align: right;">
                    <el-button type="danger" size="small" @click.stop="restoreInbox(item)">Restore Inbox</el-button>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="showContentDialog" title="Email Content" width="65%">
            <div v-html="emailContent">
            </div>
        </el-dialog>

    </div>
</template>
<script>
import {
    postRequest
} from '../../api/assistant'
import {
    formatDate
} from '../../utils/date'
import { Loading } from 'element-ui'
export default ({
    name: 'index',
    data() {
        return {
            showContentDialog: false,
            emailContent: '',
            selectMailIndex: 0,
            dataList: [],
        }
    },
    mounted() {
        this.requestData()
    },
    methods: {
        requestData() {
            let loadingInstance = Loading.service({
                text: 'Loading',
                fullscreen: true
            })
            postRequest({
                function: "getRemovedMailList"
            }).then((res) => {
                this.selectMailIndex = 0
                this.dataList = res.data.data
            }).finally(() => {
                loadingInstance.close()
            })
        },
        restoreInbox(email) {
            this.$alert('你确定要将该邮件恢复到收件箱吗？', '提示', {
                callback: action => {
                    if (action == 'confirm') {
                        postRequest({
                            function: "restoreMailToInbox",
                            mail_id: email._id.$id
                        }).then((res) => {
                            this.$message.success('恢复成功')
                            this.requestData()
                        })
                    }
                }
            })
        },

        formatReplyStatus(mail) {
            if (mail.reply_status) {
                if (mail.reply_status == -1 ) {
                    return 'No Need to Reply'
                }
                if (mail.reply_status > 0) {
                    return 'Replied'
                }
            }
            return 'Pending Reply'
        },

        formatMailDate(mail) {
            const create_time = mail.create_time
            const date = new Date(create_time * 1000)
            const utc = date.getTime() + date.getTimezoneOffset() * 60000
            const nd = new Date(utc + 8 * 60 * 60 * 1000)
            return formatDate(nd, 'yyyy-MM-dd hh:mm:ss')
        },
        handleSelectMail(email, index) {
            this.selectMailIndex = index
            this.emailContent = email.content
            this.showContentDialog = true
            //show content
        },
        createReplyStatusStyle(mail) {
            let style = { //默认是没有的，需要回复
                color: "red"
            }
            if (mail.reply_status) {//有
                if (mail.reply_status == -1) {
                    style.color = '#666'
                }
                if (mail.reply_status > 0) {
                    style.color = 'green'
                }
            }
            return style
        },
    }
})
</script>
<style scoped lang="scss">
.left-aside {
    height: calc(100vh - 60px);
    display: flex;
    background-color: white;
    flex-direction: column;
    border-left: 1px solid #f5f5f5;
    box-sizing: border-box;

    .nav-item {
        cursor: pointer;
        padding: 10px 15px;
        box-sizing: border-box;
        width: 100%;
        color: #333;
        font-size: 16px;
        background-color: white;
        border-bottom: 1px solid #f5f5f5;

        .reply {
            display: inline-block;
            margin: 0px;
            font-size: 10px;
            color: red;
        }


        .email {
            font-size: 12px;
            color: #666;

            margin: 0px;
        }

        .time {
            margin-top: 5px;
            margin-bottom: 5px;
            color: #666;
            font-size: 12px;
        }

        .subject {
            margin: 5px 0px;
            color: #333;
            font-size: 12px;
            font-weight: bold;
        }

        &:hover {
            background-color: #f5f5f5;
        }
    }

    .nav-item-selected {
        background-color: #FFD9D4;

        &:hover {
            background-color: #FFD9D4;
        }
    }

    .nav-item:last-child {
        margin-bottom: 40px;
    }
}
</style>
